import { useQuery } from '@tanstack/react-query';
import { getClinicalSiteById } from '../services/clinical_sites';

export const GetClinicalSiteById = (id) => {
  return useQuery({
    queryKey: ['clinicalSite', id],
    queryFn: () => getClinicalSiteById(id),
    enabled: !!id,
  });
};

